import { ServerErrorVO } from "./vo/ServerErrorVO";

import { SimpleCommand } from './../../../commanding/SimpleCommand';
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("BasicHandleServerErrorCommand");

export class BasicHandleServerErrorCommand extends SimpleCommand {

    public execute(commandVars: Object = null): void {
        let vo: ServerErrorVO = commandVars as ServerErrorVO;
        this.handleGameSpecificServerError(vo);
    }

    protected handleGameSpecificServerError(errorVO: ServerErrorVO): void {
        //
        logger.warn("this method is empty since the as file is also empty");
    }
}
